export const TEXT_SIZE_KEY = "mindpilot:text-size";

/** Roda antes da primeira pintura para o texto não "pular" de tamanho. */
export const textSizeScript = `try{if(localStorage.getItem("${TEXT_SIZE_KEY}")==="large")document.documentElement.dataset.textSize="large"}catch(e){}`;
